import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
  const { colors } = useContextState()
  return {
    conteiner: {
      position: 'relative'
    },
    button: {
      color: colors.color1
    },
    all: {
      display: 'flex',
      alignItems: 'center',
      '& .remove-m': {
        margin: '0px'
      }

    },
    action: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap',
      '& .MuiCheckbox-root': {
        margin: 0
      }
    },
  }
}

export { useStyles }
